import { useState } from "react";

const GUIDES = {
  iphone: {
    label: "iPhone",
    img: "/red/install-iphone.jpg",
    steps: ["Abre esta liga en Safari.", "Toca Compartir (el cuadro con la flecha hacia arriba).", "Elige \"Agregar a pantalla de inicio\" y abre CONECTA desde el ícono."],
  },
  android: {
    label: "Android",
    img: "/red/install-android.jpg",
    steps: ["Abre esta liga en Chrome.", "Toca el menú de tres puntos arriba a la derecha.", "Elige \"Instalar app\" o \"Agregar a pantalla principal\"."],
  },
};

export const InstallGuide = () => {
  const [os, setOs] = useState(/android/i.test(navigator.userAgent) ? "android" : "iphone");
  const g = GUIDES[os];
  return (
    <div data-testid="install-guide" className="c-card p-4 space-y-3">
      <p className="font-heading font-bold">Instala CONECTA en tu celular</p>
      <div className="flex gap-1.5">
        {Object.entries(GUIDES).map(([k, v]) => (
          <button key={k} data-testid={`install-tab-${k}`} onClick={() => setOs(k)}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${os === k ? "bg-[#0b2a47] text-white border-[#0b2a47]" : "c-line"}`}>{v.label}</button>
        ))}
      </div>
      <img src={g.img} alt={`Cómo instalar en ${g.label}`} className="w-full rounded-xl border c-line bg-white" />
      <ol className="space-y-1.5 text-sm c-text-2 list-decimal pl-5">{g.steps.map((s) => <li key={s}>{s}</li>)}</ol>
      <p className="text-[11px] c-muted">Tu invitación queda guardada: al abrir la app instalada podrás terminar tu registro.</p>
    </div>
  );
};
